export default __webpack_public_path__ + "645d4a5994c9fdfe97ac2cbbd9aef828.png";